import RetorikAgent from "@davi-ai/retorik-framework";
import { JsxAttribute } from "typescript";
import { BotCustomEventListenner } from "./Bot/BotCustomEventListenner";
import { botEventHandler } from "./Bot/BotEventHandler";
import { useAjadi } from "./Context/AjadiContext"
import DispositionHandler from "./DispositionHandler";
import "../styles/AjadiApp.scss"
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AjadiApp = () : JSX.Element => {
    const Ajadi = useAjadi();
    let navigate = useNavigate();
    useEffect(()=> {
        console.log("Ajadi.retorikConfig.agentData", Ajadi.retorikConfig.agentData)
        console.log("Ajadi.retorikConfig.userData", Ajadi.retorikConfig.userData)
        if(Ajadi.retorikConfig && Ajadi.retorikConfig.userData.username === ''){
            navigate("/")
        }
    }, [Ajadi.retorikConfig])
    return (
        <>
            <BotCustomEventListenner />
            <DispositionHandler/>
            <RetorikAgent 
                config={Ajadi.retorikConfig.config}
                chatbotData={Ajadi.retorikConfig.chatbotData}
                agentData={Ajadi.retorikConfig.agentData}
                addressData={Ajadi.retorikConfig.addressData}
                userData={Ajadi.retorikConfig.userData}
                ponyfillFactoryCredentials={Ajadi.retorikConfig.ponyfillFactoryCredentials}
                externalEventHandler={botEventHandler}
                customVoice={Ajadi.retorikConfig.customVoice}
                viewsConfig={Ajadi.retorikConfig.viewsConfig}           
                skipLoader={Ajadi.retorikConfig.skipLoader}
                defaultMode={Ajadi.defaultMode}
                colors={Ajadi.retorikConfig.frameworkColors}
            />
        </>
    )
}

export default AjadiApp